import { useCallback, useEffect, useRef, useState } from 'react';
export var ConnectionAuthStatus;
(function (ConnectionAuthStatus) {
    ConnectionAuthStatus["SUCCESS"] = "success";
    ConnectionAuthStatus["FAILED"] = "failed";
    ConnectionAuthStatus["PENDING"] = "pending";
})(ConnectionAuthStatus || (ConnectionAuthStatus = {}));
const DEFAULT_INTERVAL = 500;
const DEFAULT_TIMEOUT = 5 * 60 * 1000;
const DEFAULT_OPTIONS = {
    windowType: 'blank',
    timeout: DEFAULT_TIMEOUT,
    interval: DEFAULT_INTERVAL,
};
export const useOauthAuthentication = (url, onWindowClose, options) => {
    const { windowType, timeout, interval } = {
        ...DEFAULT_OPTIONS,
        ...options,
    };
    const windowName = 'embrace-oauth-popup-window';
    const windowReference = useRef(null);
    const timerRef = useRef(null);
    const intervalRef = useRef(null);
    const [data, setData] = useState(null);
    const openInNewWindow = (popupUrl) => {
        const strWindowFeatures = 'toolbar=no, menubar=no, width=1000, height=850, top=50, left=50';
        let popupWindow = windowReference.current;
        if (!popupWindow || popupWindow?.closed) {
            popupWindow =
                windowType === 'blank'
                    ? window.open(popupUrl, '_blank')
                    : window.open(popupUrl, windowName, strWindowFeatures);
        }
        else if (popupWindow?.location.href !== url) {
            popupWindow =
                windowType === 'blank'
                    ? window.open(popupUrl, '_blank')
                    : window.open(popupUrl, windowName, strWindowFeatures);
            popupWindow.focus();
        }
        else {
            popupWindow.focus();
        }
        windowReference.current = popupWindow;
    };
    const closePopup = useCallback(() => {
        if (windowReference.current && !windowReference.current.closed) {
            windowReference.current.close();
        }
    }, []);
    const startTimer = useCallback(() => {
        timerRef.current = setTimeout(() => {
            closePopup();
        }, timeout);
    }, []);
    const handleAuthComplete = useCallback((queryString = '') => {
        const searchParams = new URLSearchParams(queryString);
        const state = searchParams.get('state');
        const requestId = searchParams.get('request_id');
        if (state) {
            setData({
                status: state,
                requestId,
            });
            closePopup();
        }
    }, []);
    const authCompleteMessageListener = useCallback((e) => {
        if (e.origin !== window.location.origin) {
            return;
        }
        handleAuthComplete(e.data);
    }, []);
    const startOauthWorkflow = useCallback(() => {
        if (url) {
            openInNewWindow(url);
            window.addEventListener('message', authCompleteMessageListener, true);
            startTimer();
        }
    }, [url]);
    useEffect(() => {
        const pollingInterval = setInterval(() => {
            if (windowReference.current?.closed) {
                if (data) {
                    onWindowClose(data);
                }
                else {
                    onWindowClose({
                        status: ConnectionAuthStatus.FAILED,
                    });
                }
                clearTimeout(timerRef.current);
                window.removeEventListener('message', authCompleteMessageListener, true);
                windowReference.current = null;
            }
        }, interval);
        return () => {
            clearInterval(pollingInterval);
        };
    }, [data]);
    return {
        startOauthWorkflow,
    };
};
//# sourceMappingURL=use-oauth-authorization.js.map